// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"d3739e94","715":"86359edc","787":"b2047a9e"}[chunkId] + ".chunk.js";
};